import { useEffect, useState } from 'react'
import { toast } from 'react-hot-toast'
import { InteractiveBlock } from '../../../components/interactiveBlock/InteractiveBlock'
import { InteractiveBlocks } from '../../../components/interactiveBlock/InteractiveBlocks'
import { TopMenuButton } from '../../../components/menus/topMenu/freeroamMenuButton/TopMenuButton'
import { translations } from '../../../configs/translations'
import { ClientApi } from '../../../services/clientApi'
import { FreeroamService } from '../../../services/FreeroamService'
import PlayerService from '../../../services/PlayerService'
import { useStore } from '../../../store/store'
import { NuiMessages } from '../../../utils/ClientEvents'
import './FreeroamMenu.css'

export const FreeroamMenu = () => {

	const language = useStore(state => state.language) as keyof typeof translations
	const t = translations[language]
	const [activeTab, setActiveTab] = useState<'map' | 'race'>('map')
	const [isVisible, setIsVisible] = useState(false)

	const teleport = async (point: string) => {
		await FreeroamService.teleport(point)
			.then(() => {
				setIsVisible(false)
			}).catch((error) => {
				toast.error(error.message)
			})
	}

	const teleportPoints = {
		bathurst: {
			title: 'BATHURST',
			size: {
				width: 1,
				height: 1,
			},
			image: 'bathurst',
			buttons: [
				{
					text: t.teleport,
					action: () => teleport('bathurst')
				}
			]
		},
		nurburgring: {
			title: 'NURBURGRING',
			size: {
				width: 1,
				height: 2,
			},
			image: 'nurburgring',
			buttons: [
				{
					text: t.teleport,
					action: () => teleport('nurburgring')
				}
			]
		},
		lemans: {
			title: 'LE MANS',
			size: {
				width: 1,
				height: 2,
			},
			image: 'lemans',
			buttons: [
				{
					text: t.teleport,
					action: () => teleport('lemans')
				}
			]
		},
		sanandreas: {
			title: 'SAN ANDREAS',
			size: {
				width: 2,
				height: 2,
			},
			image: 'san-andreas',
			buttons: [
				{
					text: 'Los Santos',
					action: () => teleport('los-santos')
				},
				{
					text: 'Grand Senora',
					action: () => teleport('grand-senora')
				},
				{
					text: 'Paleto Bay',
					action: () => teleport('paleto-bay')
				}
			]
		},
		akina: {
			title: 'AKINA',
			size: {
				width: 1,
				height: 2,
			},
			image: 'akina',
			buttons: [
				{
					text: t.up,
					action: () => teleport('akina-up')
				},
				{
					text: t.down,
					action: () => teleport('akina-down')
				}
			]
		},
		fujima: {
			title: 'FUJIMA',
			size: {
				width: 1,
				height: 2,
			},
			image: 'fujima',
			buttons: [
				{
					text: t.up,
					action: () => teleport('fujima-up')
				},
				{
					text: t.down,
					action: () => teleport('fujima-down')
				}
			]
		},
		monza: {
			title: 'MONZA',
			size: {
				width: 1,
				height: 1,
			},
			image: 'monza',
			buttons: [
				{
					text: t.teleport,
					action: () => teleport('monza')
				}
			]
		},
		project_touge: {
			title: 'PROJECT TOUGE',
			size: {
				width: 1,
				height: 2,
			},
			image: 'project-touge',
			buttons: [
				{
					text: t.teleport,
					action: () => teleport('project-touge')
				}
			]
		}

	}

	const freeroamMenuComponent = () => {
		return (
			<div className='freeroam-menu'>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.lemans}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.nurburgring}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.sanandreas}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.fujima}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.akina}
				/>
				<InteractiveBlock
					type='teleport'
					data={teleportPoints.project_touge}
				/>
				<InteractiveBlocks flexDirection='column'>
					<InteractiveBlock
						type='teleport'
						data={teleportPoints.monza}
					/>
					<InteractiveBlock
						type='teleport'
						data={teleportPoints.bathurst}
					/>
				</InteractiveBlocks>
			</div>
		)
	}
	useEffect(() => {
		isVisible ? PlayerService.showCursor() : PlayerService.hideCursor()
	}, [isVisible])

	ClientApi.on(NuiMessages.SHOW_MENU, (data?: { isVisible: boolean }) => {
		if (data?.isVisible === null || data?.isVisible === undefined) {
			setIsVisible(prev => !prev)
		} else {
			setIsVisible(data.isVisible)
		}
	})

	return (
		<div className='freeroam-main-menu-wrapper' style={{ scale: 0.8, display: isVisible ? 'flex' : 'none' }}>
			<div className='freeroam-main-menu'>
				<div className='freeroam-top-menu'>
					<TopMenuButton
						text={t.teleport}
						onClick={() => setActiveTab('map')}
						isActive={activeTab === 'map'}
					/>
					<TopMenuButton
						text={t.race}
						onClick={() => setActiveTab('race')}
						isActive={activeTab === 'race'}
					/>
				</div>
				{activeTab === 'map' ? freeroamMenuComponent() : <div className='freeroam-menu'></div>}
			</div>
		</div>
	)

}